export default {"src":"/_next/static/media/jacks.f68e46ac.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};